import styled, { css, DefaultTheme, FlattenSimpleInterpolation } from 'styled-components'

import {
  getOptionHighlight,
  OptionHighlight,
} from '@/lib/core/components/Select/components/Option.utils'

export type StyledOptionProps = {
  borderColor?: string
  isDisabled?: boolean
  isFirst?: boolean
  isFocused?: boolean
  isSelected?: boolean
  minHeight?: string
}

const highlightStyles: Record<
  OptionHighlight,
  (theme: DefaultTheme) => FlattenSimpleInterpolation | null
> = {
  /**
   * The committed value. Tinted and marked with a leading accent bar so it
   * stays identifiable while the cursor sits on another row, and so the state
   * is not carried by colour alone.
   */
  selected: (theme) => css`
    box-shadow: inset ${theme.layout.spacing(0.5)} 0 0 ${theme.colors.active};
    background-color: ${theme.colors.backgroundActive};
    font-weight: 600;
  `,
  /** Wherever the pointer or keyboard is. Neutral, so it never reads as selected. */
  focused: (theme) => css`
    background-color: ${theme.colors.backgroundHighlight};
  `,
  none: () => null,
}

export const StyledOption = styled.div<StyledOptionProps>`
  display: flex;
  align-items: center;
  min-height: ${({ theme, minHeight }) => minHeight || theme.layout.spacing(7)};
  border-top: ${({ theme, borderColor }) => `1px solid ${borderColor || theme.colors.border}`};
  padding: ${({ theme: { layout } }) => `${layout.spacing(1)} ${layout.spacing(2)}`};
  background: #fff;
  color: ${({ theme: { colors }, isDisabled }) => (isDisabled ? colors.disabled : colors.text)};
  ${({ isDisabled, isFocused, isSelected, theme }) =>
    highlightStyles[getOptionHighlight({ isDisabled, isFocused, isSelected })](theme)};

  &:first-child {
    border-top-width: 0;
  }
  cursor: ${({ isDisabled }) => (isDisabled ? 'not-allowed' : 'pointer')};
`

export const StyledActionOption = styled(StyledOption)`
  gap: ${({ theme: { layout } }) => layout.spacing(1)};
  width: 100%;
  color: ${({ theme: { colors } }) => colors.active};
  line-height: 24px;
  cursor: pointer;
`
